import type { FormAnchorNavSection } from '@/components/form/form-anchor-nav.tsx'
import type { LegalEntityFormValues } from '../legal-entity/legal-entity-form.model.ts'

export const LEGAL_ENTITY_FORM_SECTIONS: FormAnchorNavSection[] = [
  { id: 'license', title: '证照原件' },
  { id: 'basic', title: '基本信息' },
  { id: 'representative', title: '法人信息' },
  { id: 'registration', title: '工商登记' },
  { id: 'payment', title: '资金账户' },
  { id: 'note', title: '内部备注' }
]

export const INITIAL_LEGAL_ENTITY_VALUES: LegalEntityFormValues = {
  businessLicenseFileIds: [],
  accounts: [],
  isLongTerm: false,
  legalRepresentative: '',
  name: '',
  operationMode: 'selfOperated',
  registeredAddress: '',
  unifiedSocialCreditCode: ''
}
